/**
 * Check-in document API hook. Same pattern as useWorkingDocument / useObjects.
 * Exposes checkinDocument thunk and CheckinApi state (checkinLoading, checkinError).
 */
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  checkinDocumentThunk,
  checkinDocumentsBulkThunk,
  clearCheckinError,
} from "../slices/checkinApi";

export function useCheckinDocument() {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.CheckinApi);

  const checkinLoading = state?.checkinLoading === true;
  const checkinBulkLoading = state?.checkinBulkLoading === true;
  const checkinError = state?.checkinError ?? null;

  const checkinDocument = useCallback(
    (payload) => dispatch(checkinDocumentThunk(payload)),
    [dispatch],
  );

  const checkinDocumentsBulk = useCallback(
    (payload) => dispatch(checkinDocumentsBulkThunk(payload)),
    [dispatch],
  );

  const clearError = useCallback(() => dispatch(clearCheckinError()), [dispatch]);

  return {
    checkinLoading,
    checkinBulkLoading,
    checkinError,
    checkinDocument,
    checkinDocumentsBulk,
    clearCheckinError: clearError,
  };
}
